module.exports = __webpack_public_path__ + "img/3-detail.44530721.jpg";